export default __webpack_public_path__ + "33ee32d7646d6cfc7cf393e3fd3f9ac4.svg";